export const SESSION_EVENT = 'dc-session-changed';

export const authRecovery = {
    recover: reason => window.dispatchEvent(new CustomEvent(SESSION_EVENT, { detail: { reason } })),
};

function storedUser() {
    try {
        const user = JSON.parse(localStorage.getItem('user'));
        return user && typeof user === 'object' && !Array.isArray(user) ? user : null;
    } catch {
        return null;
    }
}

export function readSession() {
    const user = storedUser();
    if (!user) return null;

    // Keep existing sessions compatible until their next password login.
    if (!user.token && typeof user.authdata === 'string' && user.authdata) return user;

    if (typeof user.token !== 'string' || !/^[0-9a-f]{32}\.[A-Za-z0-9_-]{43}$/.test(user.token)) return null;
    if (user.sessionSelector !== user.token.split('.')[0] || !user.id || user.accountId == null) return null;
    if (!Number.isFinite(Date.parse(user.expiresAt)) || Date.parse(user.expiresAt) <= Date.now()) return null;

    return user;
}

export function authenticatedIdentity() {
    const user = storedUser();
    if (user) return JSON.stringify([user.id, user.accountId, user.sessionSelector || user.authdata]);

    const revision = localStorage.getItem('dc-session-revision-v1');
    return revision ? JSON.stringify(['guest', revision]) : 'null';
}

function advanceGuestRevision() {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    localStorage.setItem('dc-session-revision-v1', Array.from(bytes, value => value.toString(16).padStart(2, '0')).join(''));
}

function clearAccountTargets() {
    for (const key of ['target1', 'target2', 'monthlyTargetsOEE', 'monthlyTargetsProductivity', 'dc-monthly-target-cache-v1']) {
        localStorage.removeItem(key);
    }
    sessionStorage.removeItem('ctbPurchaseOrderDraft');
}

export function notifySession() {
    window.dispatchEvent(new CustomEvent(SESSION_EVENT));
}

export function saveSession(response, expectedIdentity) {
    if (expectedIdentity !== undefined && expectedIdentity !== authenticatedIdentity()) {
        throw new Error('The account changed while signing in. Please try again.');
    }

    const user = {
        ...response.user,
        token: response.token,
        sessionSelector: response.sessionSelector,
        expiresAt: response.expiresAt,
    };
    delete user.password;
    delete user.authdata;

    if (!user.id || typeof user.token !== 'string' || !/^[0-9a-f]{32}\.[A-Za-z0-9_-]{43}$/.test(user.token)
        || user.sessionSelector !== user.token.split('.')[0] || Date.parse(user.expiresAt) <= Date.now()
        || !Number.isFinite(Date.parse(user.expiresAt))) {
        throw new Error('The server returned an invalid login session.');
    }

    clearAccountTargets();
    localStorage.setItem('user', JSON.stringify(user));
    notifySession();
    return user;
}

export function recoverSession(expectedIdentity = authenticatedIdentity(), reason = 'Please sign in again.') {
    if (expectedIdentity !== authenticatedIdentity() || !localStorage.getItem('user')) return false;

    advanceGuestRevision();
    clearAccountTargets();
    localStorage.removeItem('user');
    authRecovery.recover(reason);
    return true;
}

export function clearSession(expectedIdentity) {
    if (expectedIdentity !== authenticatedIdentity()) return false;

    advanceGuestRevision();
    clearAccountTargets();
    localStorage.removeItem('user');
    notifySession();
    return true;
}
